import React from 'react';
import CardCommon from '@op/components/CardCommon';
import { Col, Row } from 'tea-component';
import { useIntl } from 'umi';
import PurchaseAnalysisChart from '../components/PurchaseAnalysisChart';
import useSteamGameStoreAnalysis from '../../gamestore/hooks/useSteamGameStoreAnalysis';
import {
  steamPerformanceReceivedForFreeTips,
  steamPerformanceRefundGameTips,
  steamPerformanceTaggedStarTips,
} from '@/pages/opinion/components/BubbleCommon';
import '../scss/steamPurchaseAnalysis.scss';

const renderList = [
  {
    title: 'Starred Tag',
    pieKey: 'tagged_star',
    timelineKey: 'tagged_star_timeline',
    tipsMap: steamPerformanceTaggedStarTips,
  },
  {
    title: 'Free Played',
    pieKey: 'free',
    timelineKey: 'free_timeline',
    tipsMap: steamPerformanceReceivedForFreeTips,
  },
  {
    title: 'Refund Game',
    pieKey: 'refund',
    timelineKey: 'refund_timeline',
    tipsMap: steamPerformanceRefundGameTips,
  },
];

export default function SteamPurchaseAnalysis({ filter }: any) {
  const { formatMessage } = useIntl();

  const { storeSteamData, loading } = useSteamGameStoreAnalysis({
    filter,
    metrics: [
      'tagged_star_timeline',
      'tagged_star',
      'free',
      'free_timeline',
      'refund',
      'refund_timeline',
    ],
    initValue: {
      tagged_star_timeline: [],
      tagged_star: [],
      free: [],
      free_timeline: [],
      refund: [],
      refund_timeline: [],
    },
  });

  return (
    <CardCommon
      title={formatMessage({ id: 'Purchase Analysis' })}
      loading={loading}
      loadingHeight={200}
      className="steam-purchase-analysis-wrapper"
      emptyHeight={200}
    >
      <Row className="dbo-cardrow-wrap">
        {renderList.map(({ title, timelineKey, tipsMap, pieKey }) => {
          return (
            <Col key={title} span={8} className="col-item-info">
              <PurchaseAnalysisChart
                pieChartData={storeSteamData[pieKey]}
                timelineChartData={storeSteamData[timelineKey]}
                title={title}
                tipsMap={tipsMap}
                filter={filter}
              />
            </Col>
          );
        })}
      </Row>
    </CardCommon>
  );
}
